( function( $, window ) {
	'use strict';

	$( function() {
        const $ctaBar = $( '.js-feature-content-cta-bar' );
        
        function handleMarginBottom() {
            const height = $ctaBar.outerHeight();
            document.documentElement.style.setProperty( '--cta-bar-height', `${height}px` );
        }

        if ( $ctaBar.length > 0 ) {
            handleMarginBottom();

            $( window ).on( 'resize', debounce( handleMarginBottom, 300 ) );
        }
    } );
} )( jQuery, window );
